
import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoginHeader from "../components/Login/LoginHeader";
import ContinueButton from "./ContinueButton";
import { verifyUserOtp, resendOtp } from "../store/authSlice";
import { useDispatch, useSelector } from "react-redux";

const EmailVerification = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([...Array(6)].map(() => React.createRef()));
  const [isFilled, setFilled] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [isValidatingOtp, setIsValidatingOtp] = useState(false);
  const { buyerId, isParamsExist } = useSelector((state) => state.params);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const email = location.state?.email || "";
  const [isLoading, setIsLoading] = useState(false);
  
    const handleResendOtp = () => {
      setIsLoading(true);
      dispatch(resendOtp({ email }))
        .unwrap()
        .then(() => setIsLoading(false))
        .catch(() => setIsLoading(false));
    };

  useEffect(() => {
    setFilled(otp.every((digit) => digit !== ""));
  }, [otp]);

  const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1].current.focus();
    } else if (!value && index > 0) {
      inputRefs.current[index - 1].current.focus();
    }

    setOtpError(false);
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const pastedDigits = event.clipboardData
      .getData("text")
      .split("")
      .filter((digit) => /^\d$/.test(digit))
      .slice(0, 6);

    if (pastedDigits.length === 6) {
      setOtp(pastedDigits);
      inputRefs.current[5].current.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!otp) {
      setOtpError("OTP is required.");
      return;
    }

    const otpString = otp.join("");

    try {
      const payload = isParamsExist ? { email, userOtpInput: otpString,  buyerId } : { email, userOtpInput: otpString };
      const result = await dispatch(verifyUserOtp(payload));
      if (result.payload.success) {
        navigate("/password", { state: { userId: result.payload.userId } });
      } else {
        setOtpError(result.payload.message);
      }
    } catch (error) {
      setOtpError("OTP verification failed.");
    }
  };

  return (
    <>
      <LoginHeader />
      <section className="flex flex-col items-center min-h-screen justify-center bg-white py-10 overflow-scroll px-6 mt-4 sm:mt-24">
      <header className="text-center mb-14">
          <h1 className="text-2xl font-semibold text-[#1d2639]">
            Check Your Inbox
          </h1>
          <p className="text-base font-medium text-[#7e7e7e] w-full sm:w-[354px]">
            We sent a verification code to <strong>{email}</strong>. Enter it
            below to continue.
          </p>
        </header>
        <form onSubmit={handleSubmit}>
          <div className="flex justify-center gap-3">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                inputMode="numeric"
                maxLength="1"
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                onPaste={handlePaste}
                className="w-12 h-12 text-center text-lg font-semibold bg-gray-100 rounded-lg focus:outline-none"
                style={{
                  borderBottom: otpError
                    ? "3px solid red"
                    : digit !== ""
                    ? "3px solid #eaf524"
                    : "3px solid #C4C4C4",
                  borderRadius: "1px",
                }}
                ref={inputRefs.current[index]}
              />
            ))}
          </div>
          {otpError ? (
            <div className="text-red-500 text-sm mt-2 text-center" role="alert">
              Incorrect OTP. Please try again.
            </div>
          ) : (
            <p className="text-base font-medium text-[#7e7e7e] w-full sm:w-[354px] mt-10">
               Didn’t get it? Check spam or{" "}
              <button
                onClick={handleResendOtp} 
                className="hover:underline font-medium"
                disabled={isValidatingOtp}
              >
                <strong>{isLoading ? "Resending" : "Resend code"}</strong>
              </button>
              .
            </p>
          )}
        </form>

        <ContinueButton
          isDisabled={!otp || otpError || !isFilled}
          onClick={handleSubmit}
        />
      </section>
    </>
  );
};

export default EmailVerification;
